import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-774cd2ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "splash-menu-control" }
const _hoisted_2 = { class: "splash-menu-container" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "sections" }
const _hoisted_7 = { class: "section new-file" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "section-title" }, " Create a new file... ", -1))
const _hoisted_9 = { class: "section-grid" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "name" }
const _hoisted_12 = { class: "description" }
const _hoisted_13 = { class: "section open-file" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "section-title" }, " Open an existing file... ", -1))
const _hoisted_15 = { class: "section-grid" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "name" }, "+ Open a File", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description" }, "Open an existing file.", -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "product",
          src: _ctx.product
        }, null, 8, _hoisted_4),
        (_ctx.organization)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "organization",
              src: _ctx.organization
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templates, (t) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "template",
                key: t.id,
                onClick: ($event: any) => (_ctx.$emit('new', t))
              }, [
                _createElementVNode("h1", _hoisted_11, "+ " + _toDisplayString(t.name), 1),
                _createElementVNode("p", _hoisted_12, _toDisplayString(t.description), 1)
              ], 8, _hoisted_10))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", {
              class: "template",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open')))
            }, _hoisted_18)
          ])
        ])
      ])
    ])
  ]))
}